import React from 'react';
import Event from './event'

const OpacityContext = React.createContext<null | Event<number>>(null);
OpacityContext.displayName = 'OpacityContext'; // useful for react dev tools

export default OpacityContext;